import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LotSizePage from "@/pages/lot-size/page";
import MarginPage from "@/pages/margin/page";
import ProfitPage from "@/pages/profit/page";
import RiskPage from "@/pages/risk/page";
import TechnicalPage from "@/pages/technical/page";
import ComparePage from "@/pages/compare/page";
import MarketCalendarPage from "@/pages/market-calendar/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/may-tinh-khoi-luong",
    element: <LotSizePage />,
  },
  {
    path: "/may-tinh-ky-quy",
    element: <MarginPage />,
  },
  {
    path: "/lich-thi-truong",
    element: <MarketCalendarPage />,
  },
  {
    path: "/tinh-toan-loi-nhuan",
    element: <ProfitPage />,
  },
  {
    path: "/quan-tri-rui-ro",
    element: <RiskPage />,
  },
  {
    path: "/phan-tich-ky-thuat",
    element: <TechnicalPage />,
  },
  {
    path: "/doi-chieu-thi-truong",
    element: <ComparePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;